import React from "react";
import PropTypes from "prop-types";
import { Row } from "antd";
import "./styles.css";

const HeaderLeftItemsWrapper = (props) => {
  const { children, ...rest } = props;
  return (
    <Row
      justify="start"
      gutter={[16, 16]}
      className="left_header_items"
      {...rest}
    >
      {children}
    </Row>
  );
};

HeaderLeftItemsWrapper.defaultProps = {
  children: null,
};

HeaderLeftItemsWrapper.propTypes = {
  children: PropTypes.node,
};

export default HeaderLeftItemsWrapper;
